export default __webpack_public_path__ + "assets/images/bg-icon1-ec230cb5.jpg";